import type { ScopedSlotChildren } from 'vue/types/vnode'

export default function normalizeSlot(
  this: Vue,
  name = 'default',
  scope = {}
): ScopedSlotChildren {
  const slot = this.$scopedSlots[name] || this.$slots[name]
  return typeof slot === 'function' ? slot(scope) : slot
}
